// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+L5Gz","header":"styles_header__yB-LA","row":"styles_row__90-Sb","center":"styles_center__ZZd+o"};